export const LINEAR = 'LINEAR';
export const TIME = 'TIME';
export const BAND = 'BAND';
